import { staticUrl } from './config/static-assets';

// Fictional entries are presentation data, not live game announcements.
export type PortalGame = {
  id: string;
  name: string;
  genre: string;
  image: string;
  /** 门户横幅；头部焦点大图优先用，缺省回退 image */
  banner?: string;
  video?: string;
  position: string;
  description: string;
  collected?: string;
  collectedAt?: string;
  /** 热度；缺省按 0 */
  hot?: number;
  href?: string;
  /** true 时新开页（如 gamekee 外链） */
  external?: boolean;
};
export const portalGames: PortalGame[] = [
  // Only entries with href point to an existing Wiki; other games are demo fixtures.
  {
    id: 'arcanatactics',
    name: '阿尔克纳',
    genre: '策略 RPG · 英雄收集',
    image: staticUrl('/assets/aggregate/skybound-chronicle.portal.jpg'),
    position: '68% 45%',
    description: '从第一支队伍到更远的冒险，查阅英雄资料、技能与阵容攻略。',
    collected: '09.10',
    href: '/arcanatactics',
  },
  {
    id: 'lostsword',
    name: '失落之剑',
    genre: '策略 RPG · 英雄收集',
    image: staticUrl('/assets/aggregate/celestial-mage.portal.jpg'),
    position: '50% 40%',
    description: '查阅失落之剑角色资料、技能与图鉴。',
    collected: '09.17',
    href: '/lostsword',
  },
  {
    id: 'guardian-tales',
    name: '坎公骑冠剑',
    genre: '像素冒险 RPG · 英雄收集',
    image: staticUrl('/assets/guardian-tales/game-icon.png'),
    position: '50% 50%',
    description: '查阅坎公骑冠剑角色资料、技能、专武与英雄档案。',
    collected: '09.17',
    href: '/guardian-tales',
  },
  {
    id: 'starrail-demo',
    name: '星轨余晖',
    genre: '都市幻想 · 动作 RPG',
    image: staticUrl('/assets/aggregate/neon-rail.portal.jpg'),
    position: '20% 50%',
    description:
      '末班星际列车即将发车。与你的同伴穿越霓虹都市，寻找失落的星图。',
    collected: '09.09',
  },
  {
    id: 'moon-demo',
    name: '月隐之境',
    genre: '东方幻想 · 开放世界',
    image: staticUrl('/assets/aggregate/moonlit-realm.portal.jpg'),
    position: '26% 45%',
    description:
      '循着湖畔灯火，走进隐于月色的山城。与异乡旅人一起，揭开古老约定。',
  },
  {
    id: 'observatory-demo',
    name: '星穹手记',
    genre: '星象魔法 · 剧情冒险',
    image: staticUrl('/assets/aggregate/celestial-mage.portal.jpg'),
    position: '78% 35%',
    description: '在云上的观星台记录每一颗星辰，和星术师露弥一起重绘夜空。',
    collected: '09.07',
  },
  {
    id: 'cloud-demo',
    name: '雾海纪行',
    genre: '空岛探索 · 角色扮演',
    image: staticUrl('/assets/aggregate/skybound-chronicle.portal.jpg'),
    position: '91% 55%',
    description: '驾驶轻型飞艇前往云海彼岸，收集失落岛屿的故事与航路。',
  },
  {
    id: 'echo-demo',
    name: '零界回声',
    genre: '科幻冒险 · 小队策略',
    image: staticUrl('/assets/aggregate/neon-rail.portal.jpg'),
    position: '37% 30%',
    description: '接收来自边界之外的讯号，在沉睡都市中寻找最后的回声。',
    collected: '09.05',
  },
  {
    id: 'flower-demo',
    name: '花境旅人',
    genre: '幻想冒险 · 角色收集',
    image: staticUrl('/assets/aggregate/moonlit-realm.portal.jpg'),
    position: '36% 40%',
    description: '跟随花灯穿过四季交替的秘境，记录旅途中相遇的伙伴。',
    collected: '09.04',
  },
  {
    id: 'dawn-demo',
    name: '黎明星庭',
    genre: '星空幻想 · 策略 RPG',
    image: staticUrl('/assets/aggregate/celestial-mage.portal.jpg'),
    position: '72% 35%',
    description: '在星庭的长廊集结伙伴，探索黎明之前尚未点亮的星域。',
  },
];
export const portalEvents = [
  {
    day: '06',
    month: '09',
    gameId: 'arcanatactics',
    type: '版本更新',
    title: '旅程回顾',
    detail:
      '演示日程：阿尔克纳于 9 月 6 日完成版本内容更新，用于展示已经发生的游戏日程。',
  },
  {
    day: '12',
    month: '09',
    gameId: 'starrail-demo',
    current: true,
    type: '公测开启',
    title: '驶向下一站',
    detail:
      '演示日程：星轨余晖将在 9 月 12 日开放首个城市区域，小队养成与轨道探索同步开放。',
  },
  {
    day: '18',
    month: '09',
    gameId: 'cloud-demo',
    type: '抢先体验',
    title: '云海初航',
    detail:
      '演示日程：雾海纪行的探索测试计划于 9 月 18 日开启，首批航路与空岛任务将开放体验。',
  },
  {
    day: '25',
    month: '09',
    gameId: 'moon-demo',
    type: '新章上线',
    title: '月下归人',
    detail:
      '演示日程：月隐之境新篇章于 9 月 25 日上线，带来月下山城与新的旅人故事。',
  },
  {
    day: '28',
    month: '09',
    gameId: 'dawn-demo',
    type: '限时测试',
    title: '星庭初遇',
    detail:
      '虚构演示日程：黎明星庭计划开放小队策略玩法体验。本日程不代表真实上线安排。',
  },
];
export const portalNews = [
  {
    title: '星轨余晖公测日程公布',
    date: '2026.09.10',
    tag: '新游',
    gameId: 'starrail-demo',
    body: '星轨余晖的演示公测计划已公布。玩家将从中央车站出发，探索三条城市支线，与同伴一起寻找新的航路。\n\n本条新闻为页面交互演示，游戏名称、日程与玩法均为虚构内容。',
  },
  {
    title: '月隐之境：新角色「月见」亮相',
    date: '2026.09.09',
    tag: '角色',
    gameId: 'moon-demo',
    body: '来自湖畔山城的旅人月见，在本次演示预告中登场。她的故事将围绕灯会、古老约定与重逢展开。\n\n本条新闻为虚构示例，不代表真实游戏公告。',
  },
  {
    title: '雾海纪行，第一段航路即将开启',
    date: '2026.09.08',
    tag: '测试',
    gameId: 'cloud-demo',
    body: '在这份虚构的测试日程中，雾海纪行将开放首片空岛区域。探索路线、伙伴故事与航行手册将逐步解锁。\n\n本条内容用于展示新闻阅读效果。',
  },
  {
    title: '星穹手记：观星台探索预告',
    date: '2026.09.07',
    tag: '预告',
    gameId: 'observatory-demo',
    body: '虚构资讯：观星台将开放新的星图记录与伙伴剧情。本内容仅用于页面展示，不代表真实游戏公告。',
  },
];

/**
 * Calendar and news data must not depend on the order of managed Wiki games.
 * Before the portal configuration finishes loading, the supplied list may only
 * contain demo entries; fall back to the complete presentation catalogue.
 */
export function resolvePortalGame(
  games: readonly PortalGame[],
  gameId: string,
): PortalGame {
  return (
    games.find((game) => game.id === gameId) ||
    portalGames.find((game) => game.id === gameId) ||
    portalGames[0]
  );
}

export const portalCharacters = [
  {
    id: 'lumi',
    name: '露弥',
    latin: 'LUMI',
    game: '星穹手记',
    title: '云上观星者',
    image: staticUrl('/assets/aggregate/celestial-mage.portal.jpg'),
    position: '78% 38%',
    birthday: '09.12',
    arrival: '09.08',
    description:
      '「今晚的星光，会替你记住这场相遇。」\n守望云海的星术师，把旅途中的每个愿望写进星图。',
  },
  {
    id: 'lisia',
    name: '莉西亚',
    latin: 'LYSIA',
    game: '雾海纪行',
    title: '黎明的守望',
    image: staticUrl('/assets/aggregate/skybound-chronicle.portal.jpg'),
    position: '68% 40%',
    birthday: '09.18',
    arrival: '09.03',
    description:
      '「只要天光还在，我们就能找到回去的路。」\n空岛骑士团的年轻守望者，正沿着云海寻找新的航路。',
  },
  {
    id: 'tsukimi',
    name: '月见',
    latin: 'TSUKIMI',
    game: '月隐之境',
    title: '灯火中的来客',
    image: staticUrl('/assets/aggregate/moonlit-realm.portal.jpg'),
    position: '26% 40%',
    birthday: '09.22',
    arrival: '09.09',
    description:
      '「灯火还没熄，故事就还没有结束。」\n从月下山城走来的旅人，随身携带着一封未寄出的信。',
  },
  {
    id: 'night',
    name: '夜巡',
    latin: 'NOCT',
    game: '星轨余晖',
    title: '末班列车的乘客',
    image: staticUrl('/assets/aggregate/neon-rail.portal.jpg'),
    position: '36% 38%',
    birthday: '09.26',
    arrival: '09.06',
    description:
      '「下一站，去一个没有去过的地方。」\n穿梭在城市与星轨之间，追寻被遗忘的列车讯号。',
  },
  {
    id: 'weiyin',
    name: '维音',
    latin: 'VEIN',
    game: '花境旅人',
    title: '花灯的引路人',
    image: staticUrl('/assets/aggregate/moonlit-realm.portal.jpg'),
    position: '32% 45%',
    birthday: '09.28',
    arrival: '09.10',
    description:
      '「循着灯光走，就不会错过花开的地方。」\n来自四季秘境的引路人，收藏着旅途中每一段旋律。',
  },
];
